import { cached } from '@glimmer/tracking';

import type { DSData } from 'webapp-types';

import DsDataPointBase from 'webapp/models-custom/ds-data/point/base';

type DSDataPointWithTs = DSData.Point & { ts: number };

export default abstract class DsDataPointWithTs extends DsDataPointBase {
	ts: number;

	constructor(rawData: DSDataPointWithTs) {
		super(rawData);
		this.ts = rawData.ts;
	}

	get granulationLabel() {
		const granulationLabels = this.output.dataRoot.granulationLabels;
		return granulationLabels.find((item) => item.ts === this.ts)!;
	}

	@cached
	get index() {
		const granulationLabel = this.granulationLabel;
		return this.output.dataRoot.granulationLabels.indexOf(granulationLabel);
	}

	get tsEnd() {
		return this.granulationLabel.endTs;
	}
}
